import { useState, useEffect, useCallback, useContext, Suspense } from "react";
import { AuthContext, GroupContext } from "../../../../../contexts/";
import { Grid } from "@material-ui/core";
import { HealthLinksTreeView, HealthLinksGroupInformation } from "../../../";
import {
	AssignedGroup,
	AssignedLocation,
	AssignmentStatus,
	BlogGroupAndLocations,
	GroupsAndLocations,
	LocationSchema
} from "../../../../../@types/group.types";
import { UIContext } from "../../../../../contexts";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../constants/caption/dashboardHeader";
import { api } from "../../../../../utils/api";
import { useQuery } from "../../../../../hooks";

import SelectAllIcon from "@material-ui/icons/SelectAll";

import "./assignGroups.css";
import { trackPromise } from "react-promise-tracker";

const AssignGroups = () => {
	const [groups, setGroups] = useState<any[]>([]);
	const [healthLinkId, setHealthLinkId] = useState("");
	const [assignmentStatus, setAssignmentStatus] = useState<AssignmentStatus>();
	const [isValidHealthLinkId, setIsValidHealthLinkId] = useState(false);
	const { setDashboardHeader } = useContext(UIContext);
	const { groupInformation, locationInformation, setGroupInformation, setLocationInformation } =
		useContext(GroupContext);
	const { user } = useContext(AuthContext);
	const query = useQuery();

	// console.log("user._id", user?._id);

	const handleSelectProfile = (profile: GroupsAndLocations, type: "group" | "location") => {
		if (type === "group") {
			setGroupInformation(Object.assign({}, profile));
			setLocationInformation(null);
		} else if (type === "location") {
			setLocationInformation(Object.assign({}, profile));
			setGroupInformation(null);
		}
	};

	const getGroups = useCallback(
		async (id: string) => {
			if (user?._id) {
				const params = {
					user: user._id,
					blog_id: id
				};
				const result = (await trackPromise(api.healthLinks.getGroups(params))) as {
					BlogAndGroupLocations: any;
				};
				// const result = (await trackPromise(api.healthLinks.getGroups(params))) as {
				// 	groupsAndLocations: GroupsAndLocations[];
				// 	assignmentStatus: AssignmentStatus;
				// };
				// console.log(result);
				if (result) {
					setGroups(Object.assign([], result.BlogAndGroupLocations));
					// setAssignmentStatus(Object.assign({}, result.assignmentStatus));
				}
			}
		},
		[user?._id]
	);

	const handleAssignGroup = useCallback(
		async (_group: GroupsAndLocations, assigned: boolean) => {
			// console.log("_group", _group);
			// const { _id, group_number } = _group;
			// const payload = {
			// 	blog_id: healthLinkId,
			// 	group_id: _id,
			// 	group_number,
			// 	assigned,
			// 	access: "read"
			// };
			// const result = (await trackPromise(api.healthLinks.assignGroup(payload))) as {
			// 	groupsAndLocations: GroupsAndLocations[];
			// 	assignmentStatus: AssignmentStatus;
			// };
			// if (result) {
			// 	setGroups(Object.assign([], result.groupsAndLocations));
			// 	setAssignmentStatus(Object.assign({}, result.assignmentStatus));
			// }
		},
		[healthLinkId]
	);

	const handleAssignLocation = useCallback(
		async (location: LocationSchema, assigned: boolean) => {
			const { _id, group_number, location_name, location_number } = location;
			const payload = {
				blog_id: healthLinkId,
				location_name,
				group_number,
				location_id_arrays: [location_number]
				// assigned,
				// access: "read"
			};

			const result = (await trackPromise(api.healthLinks.assignLocations(payload))) as {
				BlogAndGroupLocations: BlogGroupAndLocations;
			};
			// if (result) {
			// 	setGroups(Object.assign([], result.BlogAndGroupLocations));
			// 	console.log("assigning", result, groups);
			// 	// setAssignmentStatus(Object.assign({}, result.assignmentStatus));
			// }
		},
		[healthLinkId]
	);

	const handleSaveAllGroups = useCallback(async () => {
		// console.log("hi");
	}, [assignmentStatus?.all_groups, assignmentStatus?.all_locations, groups, healthLinkId]);

	const handleSaveAllLocations = useCallback(
		async (checkedLocationsIds: any) => {
			const payload = {
				blog_id: healthLinkId,

				location_id_arrays: checkedLocationsIds
				// assigned,
				// access: "read"
			};

			const result = (await trackPromise(api.healthLinks.assignLocations(payload))) as {
				BlogAndGroupLocations: BlogGroupAndLocations;
			};
			if (result) {
				setGroups(Object.assign([], result.BlogAndGroupLocations));
				// console.log("assigning", result, groups);
				// setAssignmentStatus(Object.assign({}, result.assignmentStatus));
			}
		},
		[healthLinkId, assignmentStatus?.all_groups, assignmentStatus?.all_locations, groups]
	);

	const getHealthLinkIdValidity = useCallback(
		async (id: string) => {
			const _isValidHealthLinkId = await trackPromise(api.healthLinks.getHealthLinkValidity(id));
			if (_isValidHealthLinkId) {
				setIsValidHealthLinkId(true);
				getGroups(id);
			}
			return _isValidHealthLinkId;
		},
		[getGroups]
	);

	useEffect(() => {
		if (query) {
			setHealthLinkId(query.get("id") as string);
			getHealthLinkIdValidity(query.get("id") as string);
			setDashboardHeader(ADMIN_DASHBOARD_HEADER.limit_groups);
		}
	}, [getGroups, getHealthLinkIdValidity, query, setDashboardHeader]);

	return (
		<div className="assign-groups">
			{isValidHealthLinkId ? (
				<div className="assign-groups-container">
					<Grid container spacing={2} style={{ height: "100%" }}>
						<Grid item xl={4} lg={4} md={4} xs={12} sm={12}>
							<Suspense fallback={<div />}>
								{groups ? (
									<HealthLinksTreeView
										groups={groups}
										healthLinkId={healthLinkId}
										// assignmentStatus={assignmentStatus}
										// handleAssignGroup={handleAssignGroup}
										handleAssignLocation={handleAssignLocation}
										// handleSaveAllGroups={handleSaveAllGroups}
										// handleSaveAllLocations={() => null}
										handleSaveAllLocations={handleSaveAllLocations}
										handleSelectProfile={handleSelectProfile}
									/>
								) : null}
							</Suspense>
						</Grid>
						<Grid item xl={8} lg={8} md={8} xs={12} sm={12} className="group-info">
							<Suspense fallback={<div />}>
								{groupInformation || locationInformation ? (
									<HealthLinksGroupInformation />
								) : (
									<div className="no-result">
										<span>
											<SelectAllIcon />
										</span>
										Select a group/or location
									</div>
								)}
							</Suspense>
						</Grid>
					</Grid>
				</div>
			) : null}
		</div>
	);
};

export default AssignGroups;
